module.exports = __webpack_public_path__ + "static/img/pc_index_back.6c3cbfb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/20250903/ldt/pc_index_back.png
// module id = OUxl
// module chunks = 0